import * as actionTypes from '../actions/Actions'

export const closeOtpModal = () => ({ type: actionTypes.CLOSE_OTP_MODAL });
export const showOtpForgotModal = (phone, feature) => ({ type: actionTypes.SHOW_OTP_FORGOT_MODAL, phone, feature: feature });
export const showOtpLoginModal = (phone, feature) => ({type: actionTypes.SHOW_OTP_LOGIN_MODAL, phone: phone,feature: feature});
export const showOtpGgAuthen = (phone, authenType, feature) => ({type: actionTypes.SHOW_OTP_GG_AUTHEN, phone: phone, authenType: authenType, feature: feature});
export const goToNextStep = () => ({ type: actionTypes.GO_TO_NEXT_STEP, });
export const getMessageOtp = (notify, style) => ({type: actionTypes.GET_MESSAGE_OTP, notify, style});
export const ClearMessageOtp = () => ({type: actionTypes.CLEAR_MESSAGE_OTP});
export const showOtpSignUp = (phone, feature) => ({ type: actionTypes.SHOW_OTP_SIGN_UP_MODAL, phone: phone, feature: feature });


